<template>
  <div>
    <div class="row domains-brandingdomains-page">
      <div class="col-lg-12">
        <KTPortlet v-bind:title="$t('BRANDING.DOMAIN_LEVEL')">
          <template v-slot:body>
            <div class="row table-filter">
              <div class="col-sm-6">
                <b-form-group :label="$t('COMMON.SEL_DOMAIN')" label-for="select-domain">
                  <model-list-select
                    :list="selectDomain.allDomains"
                    v-model="selectDomain.selectedDomain"
                    option-value="domain"
                    option-text="domain"
                    @input="onChangeDomain"
                    :placeholder="$t('COMMON.SEL_DOMAIN')"
                  />
                </b-form-group>
                <p>{{ $t("BRANDING.FORM_DESC_DOMAINS") }}</p>
              </div>
            </div>

            <div>
              <b-row class="my-2">
                <b-col lg="3" class="setting-form">
                  <label for="brandname">{{ $t("BRANDING.COMPANY_NAME") }}</label>
                </b-col>
                <b-col lg="9" xl="4">
                  <b-form-input
                    id="brandname"
                    v-model="$v.settings.brandname.$model"
                    :state="validateState('brandname')"
                    :placeholder="$t('BRANDING.COMPANY_NAME')"
                    :disabled="canAdd == false"
                    aria-describedby="input-brandname-feedback"
                  />
                  <b-form-invalid-feedback id="input-brandname-feedback">
                    {{ $t("VALIDATION.REQUIRED_FIELD") }}
                  </b-form-invalid-feedback>
                </b-col>
              </b-row>

              <b-row class="my-2">
                <b-col lg="3" class="setting-form">
                  <label for="supportemail">{{ $t("BRANDING.SUPPORT_EMAIL") }}</label>
                </b-col>
                <b-col lg="9" xl="4">
                  <b-form-input
                    id="supportemail"
                    v-model="$v.settings.supportemail.$model"
                    :state="validateState('supportemail')"
                    :placeholder="$t('BRANDING.SUPPORT_EMAIL')"
                    :disabled="canAdd == false"
                    aria-describedby="input-supportemail-feedback"
                  />
                  <b-form-invalid-feedback id="input-supportemail-feedback">
                    {{ $t("VALIDATION.REQUIRED_FIELD") }}
                  </b-form-invalid-feedback>
                </b-col>
              </b-row>

              <b-row class="my-2">
                <b-col lg="3" class="setting-form">
                  <label>{{ $t("BRANDING.COMPANY_COLOR") }}</label>
                </b-col>
                <b-col lg="9" xl="4">
                  <v-color-picker
                    v-model="$v.settings.brandcolor.$model"
                    mode="hexa"
                    dot-size="25"
                  />
                </b-col>
              </b-row>

              <!-- Logo upload + preview -->
              <b-row class="my-2">
                <b-col lg="3" class="setting-form">
                  <label>
                    {{ $t("BRANDING.DEFAULT_LOGO_DESC") }} <br />
                    (max 512KB)
                  </label>
                </b-col>

                <b-col lg="9" xl="6">
                  <b-form-file
                    v-model="logoFile"
                    :disabled="canAdd == false || !selectedDomain"
                    accept=".png,.jpg,.jpeg,.gif,.webp,.svg,image/*"
                    browse-text="Browse"
                    placeholder="Choose a logo file..."
                    drop-placeholder="Drop file here..."
                    @input="onLogoSelected"
                  />

                  <!-- stored CloudFront URL (read-only) -->
                  <b-form-input class="mt-2" :value="settings.basic_logo" disabled />

                  <div class="mt-2 d-flex align-items-center">
                    <b-button
                      variant="outline-success"
                      @click="previewLogo"
                      :disabled="!settings.basic_logo && !logoDataUrl"
                    >
                      {{ $t("BRANDING.PREVIEW") }}
                    </b-button>

                <b-button
                        variant="outline-danger"
                        class="ml-2"
                        v-if="logoFile"
                        @click="clearLogoSelection"
                >
                        {{ $t("COMMON.RESET") }}
                </b-button>


                    <small class="text-muted ml-3" v-if="logoFile">
                      Selected: {{ logoFile.name }} ({{ Math.ceil(logoFile.size / 1024) }} KB)
                    </small>
                  </div>
                </b-col>
              </b-row>
            </div>

            <!-- Preview modal -->
            <b-modal
              id="previewModal"
              :title="$t('BRANDING.PREVIEW_LOGO')"
              ref="previewModal"
              hide-footer
              :body-bg-variant="bodyBgVariant"
            >
              <div class="d-flex justify-content-center">
		<div
  			class="logo-preview-frame"
  			:style="{ backgroundColor: settings.brandcolor || '#ffffff' }"
		>
                  <img
                    :src="previewLogoSrc"
                    alt="Logo preview"
                    class="logo-preview-img"
                  />
                </div>
              </div>

              <div class="text-center mt-2">
                <small class="text-white">Preview frame: 210×35</small>
              </div>
            </b-modal>
          </template>

          <template v-slot:foot>
            <b-button
              variant="primary"
              @click="updateSetting()"
              class="mr-4"
              :disabled="!selectedDomain"
            >
              {{ $t("BRANDING.UPDATE_SETTINGS") }}
            </b-button>

            <b-button
              variant="secondary"
              @click="resetSetting()"
              class="mr-4"
              :disabled="!selectedDomain"
            >
              {{ $t("BRANDING.RESET") }}
            </b-button>

          </template>
        </KTPortlet>
      </div>
    </div>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/store/breadcrumbs.module";
import { validationMixin } from "vuelidate";
import KTPortlet from "@/views/partials/content/Portlet.vue";
import { postRequest } from "@/api/request.js";
import { required } from "vuelidate/lib/validators";

export default {
  mixins: [validationMixin],
  name: "brandingdomains",
  components: { KTPortlet },
  data: () => ({
    selectDomain: {
      allDomains: [],
      selectedDomain: {},
    },
    settings: {
      brandname: "",
      brandcolor: "",
      supportemail: "",
      basic_logo: "",
    },
    bodyBgVariant: "info",

    logoFile: null,
    logoDataUrl: null,

    MAX_LOGO_BYTES: 512000,
  }),
  computed: {

    previewLogoSrc() {
      return this.logoDataUrl || this.settings.basic_logo || "";
    },

    previewIsPending() {
      return !!this.logoDataUrl;
    },

    canAdd: function () {
      return true; // or this.hasPermission("BRANDING", 5);
    },

    selectedDomain: function () {
      return this.selectDomain.selectedDomain && this.selectDomain.selectedDomain.domain
        ? this.selectDomain.selectedDomain.domain
        : null;
    },
  },
  created() {
    postRequest({
      action: "getAllDomains",
      token: localStorage.id_token,
    }).then((res) => {
      if (res) {
        if (!res.returncode) {
          res.returndata = [{ domain: res.returndata }];
        }
        this.selectDomain.allDomains = res.returndata;
        this.selectDomain.selectedDomain = {};
      }
    });

    // show admin defaults until domain selection
    postRequest({
      action: "getAdminBrandInfo",
      token: localStorage.id_token,
    }).then((res) => {
      if (res.returncode) {
        this.settings.brandname = res.returndata.brandname;
        this.settings.brandcolor = "#" + res.returndata.brandcolor;
        this.settings.supportemail = res.returndata.supportemail;
        this.settings.basic_logo = res.returndata.basic_logo;
      } else {
        this.makeToastVariant("danger", res.returndata);
      }
    });
  },
  validations: {
    settings: {
      brandname: { required },
      brandcolor: {},
      supportemail: { required },
      basic_logo: {},
    },
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: this.$t("MENU.BRANDING") }]);
  },
  methods: {

clearLogoSelection() {
  this.logoFile = null;
  this.logoDataUrl = null;
},

    validateState(name) {
      const { $dirty, $error } = this.$v.settings[name];
      return $dirty ? !$error : null;
    },

    onChangeDomain(newValue) {
      if (!newValue || !newValue.domain) return;
      this.getDomainBrandingInfo(newValue.domain);
    },

    getDomainBrandingInfo(domain) {
      // clear file selection on domain change
      this.logoFile = null;
      this.logoDataUrl = null;

      postRequest({
        action: "getDomainBrandInfo",
        token: localStorage.id_token,
        domain: domain,
      }).then((res) => {
        if (res.returncode) {
          this.settings.brandname = res.returndata.brandname;
          this.settings.brandcolor = "#" + res.returndata.brandcolor;
          this.settings.supportemail = res.returndata.supportemail;
          this.settings.basic_logo = res.returndata.basic_logo;
        } else {
          this.makeToastVariant("danger", res.returndata);
        }
      });
    },

    previewLogo() {
      this.$refs["previewModal"].show();
    },

    onLogoSelected(file) {
      this.logoDataUrl = null;

      if (!file) return;

      if (file.size > this.MAX_LOGO_BYTES) {
        this.logoFile = null;
        this.makeToastVariant("danger", "File is too big! Max 512KB.");
        return;
      }

      const allowed = [
        "image/png",
        "image/jpeg",
        "image/gif",
        "image/webp",
        "image/svg+xml",
      ];

      const name = (file.name || "").toLowerCase();
      const extOk =
        name.endsWith(".svg") ||
        name.endsWith(".png") ||
        name.endsWith(".jpg") ||
        name.endsWith(".jpeg") ||
        name.endsWith(".gif") ||
        name.endsWith(".webp");

      if (file.type && allowed.indexOf(file.type) === -1 && !extOk) {
        this.logoFile = null;
        this.makeToastVariant("danger", "Invalid file type.");
        return;
      }

      this.fileToDataUrl(file)
        .then((dataUrl) => {
          this.logoDataUrl = dataUrl;
        })
        .catch(() => {
          this.logoFile = null;
          this.logoDataUrl = null;
          this.makeToastVariant("danger", "Could not read file.");
        });
    },

    fileToDataUrl(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onerror = () => reject(new Error("read_error"));
        reader.onload = () => resolve(reader.result);
        reader.readAsDataURL(file);
      });
    },

    updateSetting() {
      this.$v.settings.$touch();
      if (this.$v.settings.$anyError) return;

      const domain = this.selectedDomain;
      if (!domain) {
        this.makeToastVariant("danger", "Please select a domain first.");
        return;
      }

      if (this.logoFile && !this.logoDataUrl) {
        this.makeToastVariant("danger", "Please wait for the logo to finish loading.");
        return;
      }

      const brand = {
        brandname: this.settings.brandname,
        brandcolor: this.settings.brandcolor.substr(1, 6),
        supportemail: this.settings.supportemail,
      };

      if (this.logoDataUrl) {
        brand.newlogo = this.logoDataUrl;
      }

      postRequest({
        action: "setDomainBranding",
        token: localStorage.id_token,
        brand: brand,
        domain: domain,
      }).then((res) => {
        if (res.returncode) {
          this.makeToastVariant("success", res.returndata);

          // refresh so preview shows the saved CloudFront URL
          this.getDomainBrandingInfo(domain);

          this.logoFile = null;
          this.logoDataUrl = null;
        } else {
          this.makeToastVariant("danger", res.returndata);
        }
      });
    },

    resetSetting() {
      const domain = this.selectedDomain;
      if (!domain) {
        this.makeToastVariant("danger", "Please select a domain first.");
        return;
      }

      postRequest({
        action: "resetDomainBranding",
        token: localStorage.id_token,
        domain: domain,
      }).then((res) => {
        if (res.returncode) {
          this.makeToastVariant("success", this.$t("COMMON.SUCCESS_ALERT") || "Success");

          this.settings.brandname = res.returndata.brandname;
          this.settings.brandcolor = "#" + res.returndata.brandcolor;
          this.settings.supportemail = res.returndata.supportemail;
          this.settings.basic_logo = res.returndata.basic_logo;

          this.logoFile = null;
          this.logoDataUrl = null;
        } else {
          this.makeToastVariant("danger", res.returndata);
        }
      });
    },

    makeToastVariant(variant = null, msg) {
      let title = this.$t("COMMON.ERROR");
      if (variant == "success") title = this.$t("COMMON.SUCCESS");

      this.$bvToast.toast(msg, {
        title: title,
        variant: variant,
        toaster: "b-toaster-top-center",
        solid: true,
      });
    },
  },
};
</script>

<style scoped>
.logo-preview-frame {
  width: 210px;
  height: 35px;

  border: 1px solid rgba(0, 0, 0, 0.25);
  border-radius: 4px;

  background: #fff;
  overflow: hidden;

  display: flex;
  align-items: center;
  justify-content: center;
}

.logo-preview-img {
  max-width: 100%;
  max-height: 100%;
  width: auto;
  height: auto;
  object-fit: contain;
  display: block;
}
</style>
